import FastMarquee from "react-fast-marquee";

const MarqueeText = () => {
  const items = [
    "THE MOST VILLAINOUS COIN ON ETHEREUM",
    "$MOJO",
    "NO TAXES",
    "JUST WORLD DOMINATION",
    "378 TRILLION SUPPLY",
    "POWERED BY EVIL GENIUS",
    "APE IN NOW",
  ];

  return (
    <div className="border-y border-[#9D4CDD]/30 py-4 bg-[#05000A] overflow-hidden" data-testid="marquee-section">
      <FastMarquee speed={50} gradient={false} className="overflow-hidden">
        {items.map((item, index) => (
          <span
            key={index}
            className="text-[#FFD700] text-xl md:text-2xl font-bold uppercase tracking-widest font-heading mx-8"
          >
            {item} •
          </span>
        ))}
      </FastMarquee>
    </div>
  );
};

export default MarqueeText;
